import { useCurrentWorkspace } from '@/context/current-workspace';
import { useSampleWorkspace } from '@/features/workspaces';
import { Strong, Text } from '@customerio/pluma-components/react';
import * as styles from './index.css';

/**
 * Sample workspace components that show visual indicators when viewing the sample workspace
 */

export function SampleWorkspaceBadge() {
  const workspace = useCurrentWorkspace();
  const { isSampleWorkspace } = useSampleWorkspace();

  if (!isSampleWorkspace(workspace?.id)) {
    return null;
  }

  return (
    <div className={styles.sampleWorkspaceBadgeContainer}>
      <div className={styles.sampleWorkspaceBadge}>
        <Text color="inherit">
          You're currently viewing the <Strong>Sample Workspace.</Strong> Switch to{' '}
          {/* oxlint-disable-next-line pluma/enforce-pluma-elements -- switching out of the sample workspace requires a full document reload until the last user workspace id is reliable. */}
          <Text as="a" href="/" textDecoration="underline">
            my workspace
          </Text>
          .
        </Text>
      </div>
    </div>
  );
}

/**
 * Sample workspace border that shows a border around the entire page when the user
 * is viewing the sample workspace.
 */
export function SampleWorkspaceBorder() {
  const workspace = useCurrentWorkspace();
  const { isSampleWorkspace } = useSampleWorkspace();

  if (!isSampleWorkspace(workspace?.id)) {
    return null;
  }

  return <div className={styles.sampleWorkspaceBorder} />;
}
